import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  FormTextarea,
  Heading,
} from "@ogt/ui";

export default function ContactDetails() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 90;
  return (
    <div>
      <Formik<FormModel>
        initialValues={{
          ...formData,
          phonenumbercontact:
            formData.phonenumberapp || formData.phonenumbercontact, // use previous phonenumber if available, or an empty string
          emailcontact: formData.valuecodeemail || formData.emailcontact, // use previous email if available, or an empty string
        }}
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/granska-och-skicka");
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          firstname: Yup.string().required("Vänligen fyll i ditt förnamn"),
          lastname: Yup.string().required("Vänligen fyll i ditt efternamn"),
          streetaddress: Yup.string().required(
            "Vänligen fyll i din gatuadress"
          ),
          zipcode: Yup.string().required("Vänligen fyll i ditt postnummer"),
          postaladdress: Yup.string().required("Vänligen fyll i din postort"),
          phonenumbercontact: Yup.string().required(
            "Vänligen fyll i ditt telefonnummer"
          ),
          emailcontact: Yup.string()
            .required("Vänligen fyll i din mejladress")
            .email("Vänligen ange en korrekt mejladress"),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading progress={progress} headingRef={h2Ref} focusable>
                  Personuppgifter
                </Heading>

                <p>
                  Till sist är det bara dina personuppgifter som vi behöver
                  veta.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="firstname"
                  label={
                    <>
                      Förnamn <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"firstname"}
                />

                <InputText
                  name="lastname"
                  label={
                    <>
                      Efternamn <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"surname"}
                />

                <InputText
                  name="streetaddress"
                  label={
                    <>
                      Gatuadress <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                />

                <InputText
                  name="zipcode"
                  label={
                    <>
                      Postnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="number"
                />

                <InputText
                  name="postaladdress"
                  label={
                    <>
                      Postort <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                />

                <InputText
                  name="phonenumbercontact"
                  label={
                    <>
                      Telefonnummer för kontakt <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="tel"
                  autocomplete={"off"}
                  numbersOnly
                />

                <InputText
                  name="emailcontact"
                  label={
                    <>
                      Mejladress för kontakt <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="email"
                  autocomplete={"email"}
                />

                <Heading as="h3">Övrig information</Heading>
                <p>
                  Ange eventuell information om din resa som du vill att vi ska
                  veta och ta till oss.
                </p>

                <FormTextarea
                  name="moreinfo"
                  maxLength={5000}
                  fielddescription
                  currentText={values.moreinfo}
                  label="Information om resan (Frivilligt)"
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
